import { View, Text, Image } from '@react-pdf/renderer';
import { styles } from './styles';
import { ICompany } from '../../../shared/interfaces';
import { useEffect, useState } from 'react';
import api from '../../../services/api';

interface IHeaderProps {
  company: ICompany | null;
}
export const RHeader: React.FC<IHeaderProps> = ({ company }) => {
  const [logo, setLogo] = useState<string | null>(null);
  const [headerLogo, setheaderLogo] = useState<string | null>(null);
  const renderText = (): string => {
    let address = '';
    address += `${company?.address},`;
    address += `${company?.number ?? 'S/N'}`;
    address += ` - ${company?.neighborhood}`;
    address += `, ${company?.city} - ${company?.state}`;
    return address;
  };

  const renderPhones = (): string => {
    let phones = '';
    phones += `Contato${company?.cell_phone ? 's' : ''}: ${company?.phone}`;
    phones += company?.cell_phone ? ` / ${company?.cell_phone}` : '';
    return phones;
  };

  const renderLogo = async () => {
    try {
      const response = await api.get(`/company/image/logos`);
      const { logo, header_logo } = response.data;
      setLogo(logo);
      setheaderLogo(header_logo);
    } catch (error) {
      setLogo(null);
      setheaderLogo(null);
    }
  };

  useEffect(() => {
    renderLogo();
  }, []);

  if (!company) return <Text>Sem informações</Text>;

  return (
    <View
      style={[
        styles.containerHeader,
        { borderWidth: logo || headerLogo ? 0 : 1, borderRadius: 6 },
      ]}
    >
      {company?.header_image && headerLogo ? (
        <Image src={headerLogo} />
      ) : (
        <>
          {company?.logo_image && logo && (
            <View style={styles.containerLogo}>
              <Image style={styles.imageLogo} src={logo} />
            </View>
          )}
          <Text style={styles.titleText}>{company.fantasy_name}</Text>
          <View style={styles.containerAddress}>
            <Text style={styles.addressText}>{renderText()}</Text>
          </View>
          <View style={styles.containerPhones}>
            <Text style={styles.phonesText}>{renderPhones()}</Text>
          </View>
        </>
      )}
    </View>
  );
};
